import React, { PureComponent } from 'react';
import classnames from 'classnames';

import { WithSize, Magnitude } from '@flyblack/common/constants';
import { getStylesWithSize } from '@flyblack/common/util';

// @ts-ignore
import style from './Spacer.sass';

export interface ISpacerProps extends WithSize<Magnitude> {
  className?: string;
}

export default class Spacer extends PureComponent<ISpacerProps> {
  render() {
    return (
      <div
        className={classnames(
          getStylesWithSize(
            (size) => (style as any)[`${size}${this.props[size] || 0}`],
            (size) => this.props[size] != null
          ),
          getStylesWithSize(
            (size) => `${size}${this.props[size] || 0}`,
            (size) => this.props[size] != null
          ),
          this.props.className
        )}
      >
        {this.props.children}
      </div>
    );
  }
}
